<svelte:head>

    <title>Billing • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../../components/utils/session.svelte";
    import Billing from "../../components/settings/billing.svelte";

</script>

<SessionManager />

<section>

    <Billing />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

</style>
